<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Politicas Integrada de Gestão</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">

        <div class="row">
        <div class="col-xs-12">
            <h3 class="box-title first">Politica Integrada de Gestão</h3>
        </div>
        </div>
        <div class="row">
            <div class="col-xs-12 static-text">
<p>Qualidade - Meio Ambiente - Segurança e Saúde Ocupacional</p>

<p>A Descarbonize Soluções S/A, situada em Maringá/PR, atua no mercado nacional em tecnologia da informação e geradores fotovoltaicos, desenvolvendo e industrializando, com distribuição autorizada de equipamentos, hardwares e softwares, através do comprometimento de todos os seus colaboradores com</p>

<ul>
<li>•	Garantia do atendimento aos requisitos legais vigentes e aos nossos próprios requisitos de qualidade, meio ambiente, segurança e saúde ocupacional;</li>
<li>•	Garantia de atendimento através dos nossos produtos com normatizações, certificações, homologações com plena funcionalidade na expectativa de uso do consumidor final;</li>
<li>•	Colaboradores competentes e qualificados para o atendimento da atuação;</li>
<li>•	Agilidade nos processos de logística;</li>
<li>•	O incentivo e a conscientização das partes interessadas para a destinação correta de resíduos tecnológicos e geração de energia limpa;</li>
<li>•	A prevenção da poluição, pautado no desenvolvimento sustentável;</li>
<li>•	Disponibilizar uma estrutura para estabelecer os objetivos de qualidade, ambientais e saúde e segurança ocupacional;</li>
<li>•	Disponibilizar ambiente de trabalho seguro e saudáveis, para a prevenção de lesões, doenças ocupacionais;</li>
<li>•	Compromisso de eliminar perigos e reduzir os riscos;</li>
<li>•	Cumprir os requisitos legais e outros requisitos de qualidade, ambientais e segurança e segurança ocupacional;</li>
<li>•	Estabelecer a consulta e participação dos trabalhadores;</li>
<li>•	Melhoria contínua da eficácia do Sistema Integrado de Gestão.</li>
</ul>
<p>Revisão 5 - aprovado 20/01/2025 por Antonio Nuno Henriques Cardoso Verças. </p>
            </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "PoliceIntegrateManager"
};
</script>
